import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiDisneyFilter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-disney-filter',
			name: 'Disney AI Filter - Disney Characters Photo Generator | Lift',
			description:
				"Turn any photo into Disney art style instantly with Lift's AI Disney filter. Transform yourself into a Disney cartoon character. No watermark.",
			url: 'https://liftapp.ai/ai-disney-filter',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-disney-filter#product' },
				{ '@id': 'https://liftapp.ai/ai-disney-filter#howto' },
				{ '@id': 'https://liftapp.ai/ai-disney-filter#benefits' },
				{ '@id': 'https://liftapp.ai/ai-disney-filter#faq' },
				{ '@id': 'https://liftapp.ai/ai-disney-filter#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-disney-filter#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-disney-filter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-disney-filter#product',
			name: 'AI Disney Style Photo Generator',
			description:
				"Relive the magic of your childhood! Transform your photos into enchanting Disney-style illustrations with Lift's AI-powered filter. Watch yourself or your loved ones come to life as whimsical cartoon characters in seconds — no drawing skills needed!",
			url: 'https://liftapp.ai/ai-disney-filter',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-disney-filter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: '🎇 Upload your image',
					text: 'Select a photo from your gallery or snap one directly in the app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: '✨ AI applies Disney magic',
					text: 'Our AI transforms your photo into authentic Disney cartoon style',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: '🖼 Apply the transformation',
					text: 'Let AI reimagine your photo in seconds',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: '🤘 Download and share',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-disney-filter#benefits',
			name: 'Who can benefit from Disney AI Filter?',
			description:
				"Lift's AI Disney Filter transforms photos into enchanting Disney-style artwork, perfect for Disney fans, social media creators, parents, content creators, and anyone looking for creative, nostalgic visuals.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Disney superfans imagining themselves as classic characters',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media creators producing nostalgic, scroll-stopping posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Parents turning family portraits into magical keepsakes',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Content creators and influencers needing whimsical storytelling visuals',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Teachers or event hosts crafting charming invites and materials',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Gift givers surprising friends with personalized Disney-style art',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Disney Art Style AI Filter',
				description:
					'Example of how Lift AI Disney Filter transforms photos into enchanting Disney-style artwork.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-disney-filter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Disney AI Filter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Disney AI Filter is an online tool that transforms your photos into authentic Disney-style artwork — capturing the warmth, charm, and iconic 2D animation style of Disney characters. Perfect for social media, gifts, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Disney AI Filter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Our AI analyzes your photo and reimagines it in Disney's signature cartoon style — with smooth lines, expressive features, vibrant colors, and that hand-drawn magic Disney is famous for. Everything happens automatically in seconds.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create a Disney-style character with any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works with any portrait photo — selfies, professional shots, or casual pics. The AI adapts to your unique features and creates custom transformations inspired by classic Disney-style aesthetics.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, prints, or personal use.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-disney-filter#why-lift',
			name: "Why Lift's Disney AI Filter stands out",
			description:
				"Lift's Disney AI Filter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Lift AI Disney Filter',
				description:
					"Comparison of Lift's AI Disney Filter benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-disney-filter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-disney-filter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Disney AI Filter',
					item: 'https://liftapp.ai/ai-disney-filter',
				},
			],
		},
	],
};
